module.exports = __webpack_public_path__ + "static/media/logo_nc.2947053c.png";